export default {
  "redPacketRain.redPacketRainConf": "RedPacketRainConfig",
  "redPacketRain.thead.index": "#No",
  "redPacketRain.thead.id": "Id",
  "redPacketRain.thead.title": "Title",
  "redPacketRain.thead.type": "Type",
  "redPacketRain.thead.OnceTask": "OnceTask",
  "redPacketRain.thead.FixedTask": "FixedTask",
  "redPacketRain.thead.scopeType": "ScopeType",
  "redPacketRain.thead.RechargeInTheLastFewDays": "Recharge In The Last Few Days",
  "redPacketRain.thead.DesignatedUser": "Designated User",
  "redPacketRain.thead.depositNearDays": "DepositNear Days",
  "redPacketRain.thead.userno": "Userno",
  "redPacketRain.thead.probabilityList": "Probability List",
  "redPacketRain.thead.amount": "Amount",
  "redPacketRain.thead.probability": "Probability",
  "redPacketRain.thead.pushTime": "pushTime",
  "redPacketRain.thead.pushTime.start": "Start Time",
  "redPacketRain.thead.pushTime.end": "End Time",
  "redPacketRain.thead.action": "Action",
  "redPacketRain.tooltip.copyUserNo": "Copy User No",
  "redPacketRain.tooltip.userDetails": "User Details",
};
